import * as React from 'react';
export function Disclaimer(_a) {
    var wholesaler = _a.wholesaler;
    return (React.createElement("div", { className: "plan-disclaimer mt-2 mb-2" },
        React.createElement("p", null,
            React.createElement("small", null,
                React.createElement("strong", null, "DISCLAIMER:"))),
        React.createElement("p", null,
            React.createElement("em", null,
                React.createElement("small", null, "Typical evening speeds are based on the download speed test results of existing customers between 7pm and 11pm and are subject to change."))),
        React.createElement("p", null,
            React.createElement("em", null,
                React.createElement("small", null,
                    "Actual speeds may be lower due to many factors including your network configuration, the location and type of content, the number of users simultaneously accessing the network, and the performance of third party interconnection infrastructure that ",
                    wholesaler,
                    " does not monitor or maintain. Wi-Fi connected devices may have slower speeds than Ethernet connected devices."))),
        React.createElement("p", null,
            React.createElement("em", null,
                React.createElement("small", null, "FTTB, FTTN and FTTC speeds cannot be confirmed. We will inform customers of their actual download speed once connected and you will have the option to downgrade to a lower speed plan without penalties.")))));
}
//# sourceMappingURL=Disclaimer.js.map